import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card, Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import PropTypes from "prop-types";
//import { connect } from "react-redux";

import ReactGA from 'react-ga4';

const Connections = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
      <section className="py-5 bg-light">
        <Container>
          <Row className="mb-5 text-center">
            <Col>
              <h2 className="display-4 font-weight-light">Our Ecosystem</h2>
              <p className="lead text-muted">Building a healthy future with our trusted friends and affiliates.</p>
            </Col>
          </Row>
          
          <Row className="g-4">
            <Col md={6} lg={4}>
              <Card className="h-100 shadow-sm border-0 rounded-lg">
                <Card.Body className="p-4">
                  <div className="mb-3 text-warning">
                    <FontAwesomeIcon icon="beer" size="2x" className="mb-2" />
                    <h5 className="font-weight-bold mb-0">Community Friends</h5>
                    <small className="text-muted">Lifestyle & Wellness</small>
                  </div>
                  <ul className="list-unstyled">
                    <li className="py-2 border-bottom"><a href="https://www.zeltazaptes.lv" target="_blank" rel="noreferrer" className="text-decoration-none text-dark">Zelta Zaptes (TM)</a></li>
                    <li className="py-2 border-bottom"><a href="https://ligaklein.art" target="_blank" rel="noreferrer" className="text-decoration-none text-dark">LigaArt (TM)</a></li>
                    <li className="py-2 border-bottom"><a href="https://www.baltuspekazimes.lv/" target="_blank" rel="noreferrer" className="text-decoration-none text-dark">Baltu Spēka Zīmes (TM)</a></li>
                    <li className="py-2"><a href="https://www.instagram.com/mananabar/" target="_blank" rel="noreferrer" className="text-decoration-none text-dark">Manana Bar Malaga (TM)</a></li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={4}>
              <Card className="h-100 shadow-sm border-0 rounded-lg">
                <Card.Body className="p-4">
                  <div className="mb-3 text-warning">
                    <FontAwesomeIcon icon="chart-bar" size="2x" className="mb-2" />
                    <h5 className="font-weight-bold mb-0">Strategic Affiliates</h5>
                    <small className="text-muted">Financial Health</small>
                  </div>
                  <ul className="list-unstyled">
                    <li className="py-2"><a href="https://www.tradreum.com/" target="_blank" rel="noreferrer" className="text-decoration-none text-dark font-weight-bold">Tradereum (TM)</a></li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4}>
              <Card className="h-100 shadow-sm border-0 rounded-lg bg-warning text-white">
                <Card.Body className="p-4 d-flex flex-column justify-content-center text-center">
                  <div className="mb-3">
                    <FontAwesomeIcon icon="envelope" size="2x" />
                  </div>
                  <h5 className="font-weight-bold mb-3">Partnership</h5>
                  <p>Interested in joining the Personalized Cloud Dashboard network?</p>
                  <a href="mailto:hx@inbox.lv?subject=Important!&body=Hi, Lets make a business together!" 
                     className="btn btn-outline-light mt-auto font-weight-bold text-uppercase py-2 shadow-sm">
                    Contact Us
                  </a>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
  );
};

export default Connections;
